import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/fr';
import {truncateText} from '../../../../../app/utils/text';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/RemoveRedEye';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../../translations/translations_schools';

const styles = theme => ({
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 16,
    },
});

class DashboardSchoolsListItem extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        const {school, classes} = this.props;

        moment.locale('fr');

        const urlView = this.props.translate('routes.schools_details').replace(':slug', school.slug);

        let languageStr = '';
        switch (school.lang) {
            case 'en': languageStr = this.props.translate('dashboard_schools.lang_en'); break;
            case 'fr': languageStr = this.props.translate('dashboard_schools.lang_fr'); break;
            default: languageStr = school.lang; break;
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={school.id}>
                <div className="item item-dashboard">
                    <div className="inner">
                        <div className="title">
                            <Link to={urlView}>
                                {ReactHtmlParser(truncateText(school.title, 70))}
                            </Link>
                            <div className="lang">
                                {languageStr}
                            </div>
                        </div>
                        <div className="bottom">
                            <Button variant="contained" size="small" color="primary" className="btn btn-view" component={props => <Link to={urlView} {...props}/>}>
                                <ViewIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                <Translate id="dashboard_schools.button_view" />
                            </Button>
                            <Button variant="contained" size="small" color="primary" className="btn btn-edit" component={props => <Link to={'/dashboard/schools/' + school.slug} {...props}/>}>
                                <EditIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                <Translate id="dashboard_schools.button_update" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DashboardSchoolsListItem.propTypes = {
    classes: PropTypes.object.isRequired,
    school: PropTypes.object.isRequired,
};

export default withStyles(styles)(withLocalize(DashboardSchoolsListItem));


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Schools/List/DashboardSchoolsListItem.js